import React, { useState } from "react";
import shareIcon from './share.png'

interface Props {
  favorites: number[];
}

const ShareButton: React.FC<Props> = ({ favorites }) => {
  const urlToShare = `https://cars.sh-dev.co.uk?cars=${favorites.join(",")}`;

  const [showNotification, setShowNotification] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Car Favourites",
          text: "Click this link to see the cars I selected.",
          url: urlToShare,
        });
      } catch (error) {
        console.warn("Share failed, falling back to clipboard:", error);
        try {
          await navigator.clipboard.writeText(urlToShare);
          setShowNotification(true);
          setTimeout(() => setShowNotification(false), 3000);
        } catch (clipboardError) {
          setModalMessage("Unable to copy the link to clipboard.");
          setShowModal(true);
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(urlToShare);
        setShowNotification(true);
        setTimeout(() => setShowNotification(false), 3000);
      } catch (clipboardError) {
        setModalMessage(
          "An error occured while trying ot copy to the clipbaord."
        );
        setShowModal(true);
      }
    }
  };

  return (
    <>
      <button className="button is-info" onClick={handleShare}>
        <img
          src={shareIcon}
          alt="Share"
          style={{ width: "20px", height: "20px", marginRight: "8px" }}
        />
        Share Favourites
      </button>

      {showNotification && (
        <div
          className="notification is-success is-light mt-3"
          style={{ width: "200px", height: "100px" }}
        >
          Sharing link copied to clipboard!
        </div>
      )}

      <div className={`modal ${showModal ? "is-active" : ""}`}>
        <div
          className="modal-background"
          onClick={() => setShowModal(false)}
        ></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Sharing Error</p>
            <button
              className="delete"
              aria-label="close"
              onClick={() => setShowModal(false)}
            ></button>
          </header>
          <section className="modal-card-body">{modalMessage}</section>
          <footer className="modal-card-foot">
            <button className="button" onClick={() => setShowModal(false)}>
              OK
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ShareButton;
